/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Whether a user agreed to the partnership they were created in.
 */
export enum EnumPartnershipConsent {
    /**
     * The user has not answered yet. Access is denied until they do.
     */
    Undecided = 0,
    /**
     * The user agreed to the partnership.
     */
    Accepted = 1,
    /**
     * The user refused the partnership.
     */
    Rejected = 2,
}
